import {createApp} from 'vue'
import FrivilligjobCard from './FrivilligjobCard'

const el = '.kb-component--frivilligjob-card'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FrivilligjobCardDOM)=>{
            const component = createApp(FrivilligjobCard).use(Store)
            component.mount(FrivilligjobCardDOM)
        })
    }
}